/**
 * „Vespera 9.0 testen“ im Menü zeigen — oberste Ebene, nicht unter „Mehr“. (29.10.2026, Martin: V9 aus der iPhone-App erreichen, ohne neuen Bau)
 *
 * Wer V9 sehen darf, entscheidet allein der Server (server/neun/konto.ts `istNeunKonto`: Konto 1 und die Testkonten aus
 * NEUN_TEST_KONTEN): /api/neun/status antwortet 200 nur dort (mit Schalter VESPERA9), sonst überall 404 ohne Spur. Die Seite kennt
 * keine feste Konto-Nummer. Unangemeldete fragen gar nicht erst. Ein Link ins Leere erscheint so nie.
 * Der Link ist ein gewöhnlicher Verweis (`href="/neun"`, kein Tab): die App-WebView bleibt in derselben Sitzung.
 */

/** Die Zeile im Menü, oberste Ebene (index.html, `#nav-neun-zeile`). */
export const NEUN_EINTRAG_ZEILE = "nav-neun-zeile";

/** Der kompakte Knopf „V9“ in der Kopfzeile (Telefon), dieselbe Bedingung (index.html, `#kopf-neun`). */
export const NEUN_KOPF_KNOPF = "kopf-neun";

/** Zeigt den Eintrag, wenn ein Konto angemeldet ist und der Server zustimmt. Gibt zurück, ob er sichtbar ist. */
export async function zeigeNeunEintrag(
  doc: Document,
  uid: number | null | undefined,
  holen: typeof fetch = (...a) => fetch(...a),
): Promise<boolean> {
  const orte = [NEUN_EINTRAG_ZEILE, NEUN_KOPF_KNOPF]
    .map((id) => doc.getElementById(id))
    .filter((e): e is HTMLElement => e !== null);
  if (orte.length === 0) return false;
  const setze = (sichtbar: boolean): void => {
    for (const e of orte) e.hidden = !sichtbar;
  };
  setze(false);
  if (typeof uid !== "number") return false;
  try {
    const r = await holen("/api/neun/status", { credentials: "same-origin" });
    setze(r.ok);
    return r.ok;
  } catch {
    return false;
  }
}
